@let brandCopy = cmsService.brandDataComponentCopy();
@let appCommonCopy = cmsService.appCommonPageCopy();
@let components = cmsService.loadedComponentsCopy();
@let page = cmsService.activePageCopy();

@let tokens = { components, page, common: appCommonCopy };

@if (featureFlagService.isFeatureActive(FeatureFlagEnum.BROCHURE_SITE)) {
  @let footerMenuCopy = cmsService.footerMenuComponentCopy();
  @if (brandCopy && appCommonCopy && footerMenuCopy) {
    @let payCta = appCommonCopy.links?.['payCta'];
    <footer class="fluid-container mt-5">
      <div class="container">
        <div class="pb-4 underline">
          <a class="d-inline-flex" routerLink="/">
            <img
              class="logo-footer"
              [src]="brandCopy.images.logo.desktopImage.url"
              [alt]="brandCopy.images.logo.desktopImage.altText"
            />
          </a>
        </div>
        <div class="d-flex align-items-start">
          <div
            class="d-flex flex-wrap gap-2 justify-content-between flex-grow-1"
          >
            @for (column of footerMenuCopy?.columns; track $index) {
              <div class="footer-menu-column">
                @for (menu of column; track $index) {
                  <div class="menu-header mt-3 fs-7 callout-head">
                    {{ menu.headerItem.label }}
                  </div>
                  @for (link of menu.menuItems; track $index) {
                    @let linkReplace =
                      {
                        image: link.image,
                        label: link.label | tokenReplace: tokens,
                        newWindow: link.newWindow,
                        url: link.url | tokenReplace: tokens,
                      };
                    <div class="menu-item">
                      @let dataQa =
                        'footer-nav-'+(linkReplace.label.replace(/\s+/g, '-')).toLowerCase();
                      <app-link
                        [inputLink]="linkReplace"
                        [inputCss]="'btn btn-link link-only'"
                        [inputAriaLabel]="linkReplace.label"
                        [inputDataQa]="dataQa"
                      ></app-link>
                    </div>
                  }
                }
              </div>
            }
          </div>

          <div class="text-end ms-4 mt-3">
            @if (payCta) {
              <app-link
                [inputLink]="payCta"
                [inputCss]="'btn btn-secondary btn-sm text-nowrap'"
                [inputAriaLabel]="payCta.label"
                [inputDataQa]="'footer-pay'"
              ></app-link>
            }
          </div>
        </div>
        <div class="d-flex copyright mt-4 fs-9">
          <div>© {{ currentYear }} {{ brandCopy?.displayName }}</div>
          @let privacyPolicyLink = appCommonCopy?.links?.['privacyPolicy'];
          @let siteMapLink = appCommonCopy?.links?.['siteMap'];
          @if (privacyPolicyLink || siteMapLink) {
            <div class="mx-2">-</div>
          }
          <div class="d-flex copyright-links">
            @if (siteMapLink) {
              <div>
                <app-link
                  [inputLink]="siteMapLink"
                  [inputCss]="'btn btn-link link-only fs-9'"
                  [inputAriaLabel]="'Site Map'"
                  [inputDataQa]="'footer-site-map'"
                ></app-link>
              </div>
            }
            @if (privacyPolicyLink) {
              <div>
                <app-link
                  [inputLink]="privacyPolicyLink"
                  [inputCss]="'btn btn-link link-only fs-9'"
                  [inputAriaLabel]="'Privacy Policy'"
                  [inputDataQa]="'footer-privacy-policy'"
                ></app-link>
              </div>
            }
          </div>
        </div>
      </div>
    </footer>
  } @else {
    <ng-container *ngTemplateOutlet="defaultFooter"></ng-container>
  }
} @else {
  <ng-container *ngTemplateOutlet="defaultFooter"></ng-container>
}
<ng-template #defaultFooter>
  <footer class="fluid-container mt-5">
    <div class="container">
      <div class="row">
        <div class="col"></div>
      </div>
    </div>
  </footer>
</ng-template>
